export function LoadingPage({ label = 'Opening your place in the fieldbook' }: { label?: string }) {
  return (
    <main className="state-page" id="main-content" aria-busy="true">
      <p className="loading-label">{label}</p>
      <div className="loading-lines" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    </main>
  );
}

export function ErrorPage({ error, retry }: { error: Error; retry: () => void }) {
  return (
    <main className="state-page" id="main-content">
      <h1>The fieldbook did not open</h1>
      <p>{error.message}</p>
      <p>Check that the generated files exist under public/data, then try again.</p>
      <button className="primary-button" type="button" onClick={retry}>
        Try again
      </button>
    </main>
  );
}
